interface Props {
  className?: string
  width?: string | number
  height?: string | number
}

export const FooterArch = (props: Props) => {
  const { className, width = '100%', height = '100%' } = props

  const parsedWidth = typeof width === 'number' ? `${width}px` : width
  const parsedHeight = typeof height === 'number' ? `${height}px` : height

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={parsedWidth}
      height={parsedHeight}
      viewBox="0 0 1440 269"
      fill="none"
      className={`${className} ${className?.search('fill') === -1 ? 'fill-black' : ''} h-auto`}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 268.998L1440 268.999L1440 6.10352e-05C1231.7 132.924 984.339 209.944 719 209.944C454.51 209.944 207.878 133.415 2.34052e-05 1.2738L0 268.998Z"
        fill="currentColor"
      />
    </svg>
  )
}
